import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    root: {
        marginRight: 6,
        width: 20,
        height: 20,
        alignSelf: 'center',
    },
});

export default styles;
